<template>
  <div class="ventas-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroPeriodo="filtroPeriodo"
          :filtroNumero="filtroNumero"
          :filtroNumeroPresupuesto="filtroNumeroPresupuesto"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :cliente="cliente"
          :numeroCertificado="numeroCertificado"
          :incluirComprobantesIva="incluirComprobantesIva"
          :numero="numero"
          :numeroPuntoVenta="numeroPuntoVenta"
          :comprobanteTipo="comprobanteTipo"
          :numeroPresupuesto="numeroPresupuesto"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card header="Registro de Facturación">
            <b-row>
              <b-col class="ventas-seleccionar-todo">
                <label class="text-muted">Seleccionar todos / eliminar selección</label>
                <b-form-checkbox v-model="estadoComprobantesSeleccionados" :indeterminate.sync="estadoComprobantesSeleccionadosIndeterminado" @click.native.prevent="actualizarSeleccionComprobantes">
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-table
              hover
              responsive="sm"
              :class="{
                registro: true,
                arg: paisId == 1 ? true : false,
              }"
              :busy="tableBusy"
              :items="ventas"
              :fields="ventasFields"
              @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaComprobante)="data">
                {{ data.item.fechaComprobante | fecha }}
              </template>
              <template v-slot:cell(fechaVencimiento)="data">
                {{ data.item.fechaVencimiento | fecha }}
              </template>
              <template v-slot:cell(total)="data">
                {{ data.item.total | moneda(data.item.moneda) }}
              </template>
              <!-- <template v-slot:cell(montoTotal)="data">
              {{ data.item.montoTotal | moneda }}
            </template> -->
              <template v-slot:cell(opciones)="data">
                <template v-if="ventasSeleccionadas.length != 0">
                  <b-form-checkbox v-model="data.item.selected" :value="Boolean(true)" :unchecked-value="Boolean(false)" @change="actualizarSeleccion(data.item)"> </b-form-checkbox>
                </template>

                <template v-if="ventasSeleccionadas.length == 0">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>

                    <b-dropdown-item v-if="opcionValidarAfip" @click.stop="validarComprobante(data.item)"> <i class="fa fa-check"></i>Validar Comprobante AFIP</b-dropdown-item>

                    <b-dropdown-item v-if="opcionActualizarCAE" @click.stop="actualizarCAE(data.item)"> <i class="fa fa-edit"></i>Actualizar CAE</b-dropdown-item>

                    <b-dropdown-item v-if="opcionNegociarComprobante && !data.item.negociada"  @click.stop="registrarNegociacion(data.item)"> <i class="fa fa-edit"></i>Registrar Negociación Comprobante</b-dropdown-item>

                    <b-dropdown-item v-if="opcionNegociarComprobante && data.item.negociada"  @click.stop="eliminarNegociacion(data.item)"> <i class="fa fa-remove"></i>Borrar Negociación</b-dropdown-item>

                    <b-dropdown-item v-if="opcionActualizarFechaImputacion" @click.stop="actualizarFechaImputacion(data.item)">
                      <i class="fa fa-edit"></i>Actualizar Fecha de Imputación</b-dropdown-item
                    >

                    <b-dropdown-item v-if="opcionActualizarExclusionIndicadores && !data.item.excluidoIndicadorVentas" @click.stop="excluirCalculoIndicadores(data.item)">
                      <i class="fa fa-edit"></i>Excluir del Cálculo de Indicadores</b-dropdown-item
                    >

                    <b-dropdown-item v-if="opcionActualizarExclusionIndicadores && data.item.excluidoIndicadorVentas" @click.stop="incluirCalculoIndicadores(data.item)">
                      <i class="fa fa-edit"></i>Incluir en Cálculo de Indicadores</b-dropdown-item
                    >

                    <b-dropdown-item @click.stop="emitirComprobante(data.item)"> <i class="fa fa-file-pdf-o"></i>Emitir Comprobante</b-dropdown-item>

                    <b-dropdown-item v-if="!data.item.facturaExportacion" @click.stop="creditoDebito(data.item)"> <i class="fa fa-plus"></i>Generar NCR/NDB</b-dropdown-item>

                    <b-dropdown-item v-if="!data.item.facturaExportacion && data.item.monedaId == 101" @click.stop="creditoFinanciacion(data.item)">
                      <i class="fa fa-plus"></i>Generar Crédito por Financiación</b-dropdown-item
                    >

                    <b-dropdown-item v-if="!data.item.facturaExportacion && data.item.monedaId == 101" @click.stop="creditoFee(data.item)">
                      <i class="fa fa-plus"></i>Generar Crédito por Fee</b-dropdown-item
                    >

                    <b-dropdown-item v-if="opcionCancelarComprobante" @click.stop="cancelarComprobante(data.item)"> <i class="fa fa-remove"></i>Cancelar Comprobante</b-dropdown-item>

                    <b-dropdown-item @click.stop="borrarComprobante(data.item)"> <i class="fa fa-remove"></i>Borrar Comprobante</b-dropdown-item>

                    <b-dropdown-item @click.stop="seleccionarVenta(data.item)"> <i class="fa fa-check"></i>Seleccionar Comprobante</b-dropdown-item>
                  </b-dropdown>
                </template>
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="totalRegistros" :per-page="registrosPorPagina" v-model="paginaActual" prev-text="Prev." next-text="Prox." />
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-row v-if="ventasSeleccionadas.length != 0">
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card header="Totales Seleccionados">
            <b-row>
              <b-col cols="4" xl="4">
                <b-form-group label="Cantidad" label-for="seleccionadasPesosCantidad" :label-cols="labelCols" description="Cantidad de comprobantes ($)" horizontal>
                  <b-form-input id="seleccionadasPesosCantidad" :value="seleccionadasPesosCantidad" readonly> </b-form-input>
                </b-form-group>

                <b-form-group label="Total" label-for="seleccionadasPesosImporte" :label-cols="labelCols" description="Importe total ($)" horizontal>
                  <b-form-input id="seleccionadasPesosImporte" :value="seleccionadasPesosImporte | moneda" readonly> </b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="4" xl="4">
                <b-form-group label="Cantidad" label-for="seleccionadasDolaresCantidad" :label-cols="labelCols" description="Cantidad de comprobantes (USD)" horizontal>
                  <b-form-input id="seleccionadasDolaresCantidad" :value="seleccionadasDolaresCantidad" readonly> </b-form-input>
                </b-form-group>

                <b-form-group label="Total" label-for="seleccionadasDolaresImporte" :label-cols="labelCols" description="Importe total (USD)" horizontal>
                  <b-form-input id="seleccionadasDolaresImporte" :value="seleccionadasDolaresImporte | moneda('u$s')" readonly> </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-modal ref="cancelacionModal" title="Cancelar Comprobante" header-bg-variant="light" hide-footer lazy modal-class="modalABM">
      <app-cancelacion :cliente="cancelacionCliente" :comprobante="cancelacionComprobante" :esFCE="cancelacionEsFCE" @cancelarComprobante="cancelar" @cancelarCancelacion="cancelarCancelacion">
      </app-cancelacion>
    </b-modal>

    <!-- <b-modal ref="actualizacionCAEModal"
        title="Actualizar CAE"
        header-bg-variant= "light"
        hide-footer
        lazy
        modal-class="modalABM">
      <app-actualizacion
        :ventaId="ventaId"
        @closeActualizacion="closeActualizacionCAE">
      </app-actualizacion>
    </b-modal> -->

    <b-modal ref="actualizacionFechaImputacion" title="Actualizar Fecha de Imputación" header-bg-variant="light" hide-footer lazy modal-class="modalABM">
      <app-actualizacion-fecha-imputacion :ventaId="ventaId" @closeActualizacion="closeActualizacionFechaImputacion"> </app-actualizacion-fecha-imputacion>
    </b-modal>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>

          <b-dropdown-item v-if="opcionFacturaCertificados" @click.stop="agregarVentaCertificados"> <i class="fa fa-plus"></i>Factura por Certificados</b-dropdown-item>
          <b-dropdown-item v-if="opcionFacturaConceptos" @click.stop="agregar"> <i class="fa fa-plus"></i>Factura por Concepto</b-dropdown-item>
          <b-dropdown-item v-if="opcionFacturaExportacionCertificados" @click.stop="agregarVentaCertificadosExportacion">
            <i class="fa fa-plus"></i>Factura de Exportación por Certificados</b-dropdown-item
          >
          <b-dropdown-item v-if="opcionFacturaExportacionConceptos" @click.stop="agregarVentaExportacion"> <i class="fa fa-plus"></i>Factura de Exportación por Concepto</b-dropdown-item>
          <b-dropdown-item v-if="opcionCreditoFinanciacion" @click.stop="agregarCreditoFinanciacion"> <i class="fa fa-plus"></i>Crédito por Financiación</b-dropdown-item>
          <b-dropdown-item :disabled="filtroNumero" @click.stop="exportXls"> <i class="fa fa-file-excel-o"></i>Exportar Listado de Comprobantes</b-dropdown-item>
          <b-dropdown-item v-if="ventasSeleccionadas.length != 0" @click.stop="cancelarSeleccion"> <i class="fa fa-remove"></i>Cancelar Selección</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje :modalMsj="modalMsj" :modalMensaje="modalMensaje" @okAction="okAction" @hiddenAction="hiddenAction"> </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue'
import Cancelacion from './Cancelacion.vue'
import ActualizacionCAE from './ActualizacionCAE.vue'
import ActualizacionFechaImputacion from './ActualizacionFechaImputacion.vue'
import Mensaje from '../shared/msjModal.vue'
import Confirm from '../shared/confirmModal.vue'
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import export_xls_ventas from '../../mixins/export_xls_ventas'
import exportFacturaPDF from '../../mixins/export_factura_pdf'
import exportFacturaChilePDF from '../../mixins/export_factura_chile_pdf'
import exportFacturaExportacionPDF from '../../mixins/export_factura_exportacion_pdf'
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'ventas/getField',
  mutationType: 'ventas/updateField',
})

export default {
  name: 'Ventas',
  components: {
    appFiltro: Filtro,
    appCancelacion: Cancelacion,
    appActualizacion: ActualizacionCAE,
    appActualizacionFechaImputacion: ActualizacionFechaImputacion,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [msjModal, confirmModal, exportFacturaPDF, exportFacturaChilePDF, exportFacturaExportacionPDF, export_xls_ventas],
  data: () => {
    return {
      ventaId: 0,
      cancelacionCliente: '',
      cancelacionComprobante: '',
      cancelacionEsFCE: false,
      tableBusy: false,

      opcionValidarAfip: false,
      opcionActualizarCAE: false,
      opcionCancelarComprobante: false,
      opcionActualizarFechaImputacion: false,
      opcionActualizarExclusionIndicadores: false,

      opcionFacturaCertificados: false,
      opcionFacturaConceptos: false,
      opcionFacturaExportacionCertificados: false,
      opcionFacturaExportacionConceptos: false,
      opcionCreditoFinanciacion: false,
      opcionNegociarComprobante: false,

      labelCols: 3,
    }
  },
  computed: {
    ...mapFields([
      'ventas',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',

      'filtroPeriodo',
      'filtroNumero',
      'filtroNumeroPresupuesto',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'numeroCertificado',
      'incluirComprobantesIva',
      'numero',
      'numeroPuntoVenta',
      'comprobanteTipo',
      'numeroPresupuesto',
      'sortByDescending',

      'ventasSeleccionadas',
      'seleccionadasPesosCantidad',
      'seleccionadasPesosImporte',
      'seleccionadasDolaresCantidad',
      'seleccionadasDolaresImporte',

      'comprobantesSeleccionados',
      'comprobantesSeleccionadosIndeterminado',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD')
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD')
    },
    paisId() {
      return parseInt(this.$store.getters['user/paisId'])
    },
    ventasFields() {
      let fields = [
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.',
          sortable: true,
        },
        {
          key: 'fechaVencimiento',
          label: 'Fecha Vencim.',
        },
        {
          key: 'cliente',
          sortable: true,
        },
        {
          key: 'comprobante',
          sortable: true,
        },
        {
          key: 'total',
          // key: 'montoTotal',
          class: 'text-right',
        },
        // {
        //   key: 'cae',
        //   label: 'CAE'
        // },
        // {
        //   key: 'opciones',
        //   label: '',
        //   class: 'text-center'
        // },
      ]

      if (this.paisId == 1) {
        fields.push({
          key: 'cae',
          label: 'CAE',
        })
      }

      fields.push({
        key: 'opciones',
        label: '',
        class: 'text-center',
      })

      return fields
    },
    estadoComprobantesSeleccionados: {
      get: function () {
        return this.comprobantesSeleccionados
      },
      set: function (newValue) {},
    },
    estadoComprobantesSeleccionadosIndeterminado: {
      get: function () {
        return this.comprobantesSeleccionadosIndeterminado
      },
      set: function (newValue) {},
    },
  },
  created() {
    let route = this.$router.resolve({ name: 'VentaABMCertificados' }).route
    this.opcionFacturaCertificados = Boolean(this.$store.getters['user/tieneAcceso'](route))
    route = this.$router.resolve({ name: 'VentaABM' }).route
    this.opcionFacturaConceptos = Boolean(this.$store.getters['user/tieneAcceso'](route))
    route = this.$router.resolve({ name: 'VentaABMCreditoFinanciacionComprobantes' }).route
    this.opcionCreditoFinanciacion = Boolean(this.$store.getters['user/tieneAcceso'](route))
    this.opcionActualizarFechaImputacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('VentasActualizarFechaImputacion'))
    this.opcionActualizarExclusionIndicadores = Boolean(this.$store.getters['user/tieneAccesoModulo']('VentasExcluirCalculoIndicadores'))
    this.opcionNegociarComprobante = Boolean(this.$store.getters['user/tieneAccesoModulo']('VentasNegociarComprobante'))

    if (this.paisId == 1) {
      route = this.$router.resolve({ name: 'VentaABMCertificadosExportacion' }).route
      this.opcionFacturaExportacionCertificados = Boolean(this.$store.getters['user/tieneAcceso'](route))
      route = this.$router.resolve({ name: 'VentaABMExportacion' }).route
      this.opcionFacturaExportacionConceptos = Boolean(this.$store.getters['user/tieneAcceso'](route))

      this.opcionValidarAfip = Boolean(this.$store.getters['user/tieneAccesoModulo']('VentasValidarAFIP'))
      // this.opcionActualizarCAE = Boolean(this.$store.getters['user/tieneAccesoModulo']('VentasActualizarCAE'));
      this.opcionActualizarCAE = false
      this.opcionCancelarComprobante = true
    } else {
      this.opcionValidarAfip = false
      this.opcionActualizarCAE = false
      this.opcionCancelarComprobante = false
    }

    let userRolId = parseInt(this.$store.getters['user/rolId'])
    if (userRolId == 1) {
      this.opcionActualizarCAE = true
    }

    this.getItems()
  },
  methods: {
    filtrar(filtro) {
      this.filtroPeriodo = filtro.filtroPeriodo
      this.filtroNumero = filtro.filtroNumero
      this.filtroNumeroPresupuesto = filtro.filtroNumeroPresupuesto
      this.fechaDesde = filtro.fechaDesde
      this.fechaHasta = filtro.fechaHasta
      this.cliente = filtro.cliente
      this.numeroCertificado = filtro.numeroCertificado
      this.incluirComprobantesIva = filtro.incluirComprobantesIva
      this.numero = filtro.numero
      this.numeroPuntoVenta = filtro.numeroPuntoVenta
      this.comprobanteTipo = filtro.comprobanteTipo
      this.numeroPresupuesto = filtro.numeroPresupuesto
      this.sortByDescending = filtro.sortByDescending
      this.paginaActual = 1

      /* Al filtrar limpiamos la selección */
      this.$store.dispatch('ventas/inicializarVentasSeleccionadas').then(() => this.getItems())
    },
    getItems() {
      // console.log('getItems');
      this.tableBusy = true
      this.$store
        .dispatch('ventas/getVentas')
        .then(() => (this.tableBusy = false))
        .catch((error) => this.showErrorMsj(error))
    },
    agregar() {
      this.$router.push({ name: 'VentaABM' })
    },
    agregarVentaExportacion() {
      this.$router.push({ name: 'VentaABMExportacion' })
    },
    agregarVentaCertificados() {
      this.$router.push({ name: 'VentaABMCertificados' })
    },
    agregarVentaCertificadosExportacion() {
      this.$router.push({ name: 'VentaABMCertificadosExportacion' })
    },
    agregarCreditoFinanciacion() {
      this.$router.push({ name: 'VentaABMCreditoFinanciacionComprobantes' })
    },
    consultar(item) {
      this.$router.push({ name: 'VentaData', params: { id: item.id } })
    },
    borrarComprobante(item) {
      this.showModalConfirm('¿Desea borrar la venta seleccionada?', this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar(ventaId) {
      this.showSpinner()
      this.$store
        .dispatch('ventas/delete', ventaId)
        .then(() => this.showModalMsj('El comprobante se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    emitirComprobante(item) {
      this.showSpinner()
      let datosEmpresa = {}

      this.$store
        .dispatch('empresa/inicializar')
        .then(() => {
          return this.$store.getters['empresa/empresa']
        })
        .then((empresa) => {
          datosEmpresa = empresa
          return this.$store.dispatch('venta/getDatosRpt', item.id)
        })
        .then(() => {
          if (/true/i.test(item.facturaExportacion)) {
            this.exportFacturaExportacionPDF(this.$store.getters['venta/ventaDatosRpt'], this.$store.getters['venta/ventaRenglonesDescripcionDatosRpt'], datosEmpresa)
          } else {
            let paisId = this.$store.getters['user/paisId']

            if (paisId == 5) {
              this.exportFacturaChilePDF(this.$store.getters['venta/ventaDatosRpt'], this.$store.getters['venta/ventaRenglonesDescripcionDatosRpt'], datosEmpresa)
            } else {
              this.exportFacturaPDF(this.$store.getters['venta/ventaDatosRpt'], this.$store.getters['venta/ventaRenglonesDescripcionDatosRpt'], datosEmpresa)
            }
          }
        })
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    validarComprobante(item) {
      // if ((/true/i).test(item.facturaExportacion)) {
      //   this.showModalMsj('Esta opción no se encuentra disponible para el tipo de comprobante seleccionado', null, null, 'light');
      //   return;
      // }

      this.showSpinner()
      let params = {
        ventaId: item.id,
      }

      this.$store
        .dispatch('facturaelectronica/validarComprobante', params)
        .then(() => {
          let validado = this.$store.getters['facturaelectronica/validado']

          if (validado) {
            this.showModalMsj('El comprobante se validó con éxito', this.getItems, this.getItems, 'light')
          } else {
            let msjValidacion = this.$store.getters['facturaelectronica/msjValidacion']
            this.showErrorMsj('El comprobante no se pudo validar.' + msjValidacion)
          }
        })
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },

    cancelarComprobante(item) {
      this.ventaId = item.id
      this.cancelacionCliente = item.cliente
      this.cancelacionComprobante = item.comprobante
      /* Habilitamos la opción para todos los tipos de comprobante electrónico */
      this.cancelacionEsFCE = item.comprobante.includes('FCE') || item.comprobante.includes('NCE') || item.comprobante.includes('NDE')

      this.$refs.cancelacionModal.show()
    },
    cancelar(params) {
      this.$refs.cancelacionModal.hide()

      params.ventaId = this.ventaId

      this.showSpinner()
      this.$store
        .dispatch('ventas/cancelar', params)
        .then(() => this.showModalMsj('El comprobante se canceló con éxito', this.getItems, this.getItems, 'light'))
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    cancelarCancelacion() {
      this.$refs.cancelacionModal.hide()
    },
    creditoDebito(item) {
      if (/true/i.test(item.facturaExportacion)) {
        this.showModalMsj('Esta opción no se encuentra disponible.', null, null, 'warning')
      } else {
        this.$router.push({ name: 'VentaABMCreditoDebito', params: { id: item.id } })
      }
    },
    creditoFinanciacion(item) {
      if (/true/i.test(item.facturaExportacion)) {
        this.showModalMsj('Esta opción no se encuentra disponible.', null, null, 'warning')
      } else {
        this.$router.push({ name: 'VentaABMCreditoFinanciacion', params: { id: item.id } })
      }
    },
    creditoFee(item) {
      if (/true/i.test(item.facturaExportacion)) {
        this.showModalMsj('Esta opción no se encuentra disponible.', null, null, 'warning')
      } else {
        this.$router.push({ name: 'VentaABMCreditoFee', params: { id: item.id } })
      }
    },
    registrarNegociacion(item) {
      if (/true/i.test(item.facturaExportacion)) {
        this.showModalMsj('Esta opción no se encuentra disponible.', null, null, 'warning')
      } else {
        this.$router.push({ name: 'VentaNegociacion', params: { id: item.id } })
      }
    },
    eliminarNegociacion(item) {
      this.showModalConfirm('¿Desea borrar la negociación del comprobante seleccionado?', this.eliminarNegociacionComprobante.bind(this, item.id), 'Si', null, 'No')
    },
    eliminarNegociacionComprobante(ventaId) {
      this.showSpinner()
      this.$store.dispatch('ventas/deleteNegociacion', ventaId)
        .then(() => this.showModalMsj('La negociación del comprobante se eliminó con éxito', this.getItems, this.getItems, 'light'))
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    exportXls() {
      let clienteId = 0
      if (this.cliente) {
        if (this.cliente.id) {
          clienteId = this.cliente.id
        }
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        clienteId,
        numeroCertificado: this.numeroCertificado,
      }

      this.showSpinner()
      this.$store
        .dispatch('ventas/getRptVentas', params)
        .then(() => {
          let exportRpt = Boolean(false)
          let rptVentas = this.$store.getters['ventas/rptVentas']

          if (rptVentas) {
            if (rptVentas.length != 0) {
              exportRpt = Boolean(true)
            }
          }
          if (exportRpt) {
            this.exportXLSRptVentas(rptVentas)
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    actualizarCAE(item) {
      this.showSpinner()
      let params = {
        ventaId: item.id,
      }

      this.$store
        .dispatch('facturaelectronica/actualizarDatosValidacion', params)
        .then(() => {
          let validado = this.$store.getters['facturaelectronica/validado']

          if (validado) {
            this.showModalMsj('La información de la validación se actualizó con éxito', this.getItems, this.getItems, 'light')
          } else {
            let msjValidacion = this.$store.getters['facturaelectronica/msjValidacion']
            this.showErrorMsj('La información de la validación no se pudo actualizar.' + msjValidacion)
          }
        })
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    // actualizarCAE (item) {
    //   this.ventaId = item.id;
    //   this.$refs.actualizacionCAEModal.show();
    // },
    // closeActualizacionCAE(ventaActualizada) {
    //   this.$refs.actualizacionCAEModal.hide();

    //   if ((/true/i).test(ventaActualizada)) {
    //     this.getItems();
    //   }
    // },
    actualizarFechaImputacion(item) {
      this.ventaId = item.id
      this.$refs.actualizacionFechaImputacion.show()
    },
    closeActualizacionFechaImputacion() {
      this.$refs.actualizacionFechaImputacion.hide()
    },

    seleccionarVenta(item) {
      this.$store.dispatch('ventas/seleccionarVenta', item)
    },
    actualizarSeleccion(item) {
      this.$store.dispatch('ventas/actualizarVentaSeleccionada', item)
    },
    cancelarSeleccion() {
      this.$store.dispatch('ventas/inicializarVentasSeleccionadas')
    },
    actualizarSeleccionComprobantes() {
      this.$store.dispatch('ventas/actualizarSeleccion')
    },
    incluirCalculoIndicadores(item) {
      this.showModalConfirm('¿Desea incluir la venta seleccionada en el cálculo de los indicadores?', this.incluirCalculo.bind(this, item.id), 'Si', null, 'No')
    },
    incluirCalculo(ventaId) {
      this.showSpinner()
      this.$store
        .dispatch('ventas/incluirCalculoIndicadores', ventaId)
        .then(() => this.showModalMsj('El comprobante se actualizó con éxito', this.getItems, this.getItems, 'light'))
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    excluirCalculoIndicadores(item) {
      this.showModalConfirm('¿Desea excluir la venta seleccionada del cálculo de los indicadores?', this.excluirCalculo.bind(this, item.id), 'Si', null, 'No')
    },
    excluirCalculo(ventaId) {
      this.showSpinner()
      this.$store
        .dispatch('ventas/excluirCalculoIndicadores', ventaId)
        .then(() => this.showModalMsj('El comprobante se actualizó con éxito', this.getItems, this.getItems, 'light'))
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
  },
  watch: {
    paginaActual: function (newVal, oldVal) {
      if (newVal != 0 && oldVal != 0) {
        this.getItems()
      }
    },
  },
}
</script>

<style>
.ventas-list .registro table th {
  border-top: none;
}
.ventas-list .registro table td[aria-colindex='1'] {
  width: 10%;
}
.ventas-list .registro table td[aria-colindex='2'] {
  width: 10%;
}
.ventas-list .registro table td[aria-colindex='3'] {
  width: calc(50% - 60px);
}
.ventas-list .registro table td[aria-colindex='4'] {
  width: 15%;
}
.ventas-list .registro table td[aria-colindex='5'] {
  width: 15%;
}
.ventas-list .registro table td[aria-colindex='6'] {
  width: 60px;
}

.ventas-list .registro.arg table td[aria-colindex='3'] {
  width: calc(40% - 60px);
}
.ventas-list .registro.arg table td[aria-colindex='6'] {
  width: 10%;
}
.ventas-list .registro.arg table td[aria-colindex='7'] {
  width: 60px;
}

.ventas-seleccionar-todo {
  display: inline-block;
  text-align: right;
  margin-bottom: 10px;
  padding-right: 30px;
}
.ventas-seleccionar-todo label {
  display: inline-block;
  font-size: 12px;
}
.ventas-seleccionar-todo .custom-checkbox {
  display: inline-block;
  width: 40px;
}
</style>
